import React from "react";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";
import SpeakerNotesIcon from "@material-ui/icons/SpeakerNotes";
import PeopleIcon from "@material-ui/icons/People";
import ForumIcon from "@material-ui/icons/Forum";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import ChatIcon from '@material-ui/icons/Chat';

export const MenuCategories = {
  admin: {
    id: "admin",
    name: "مدیریت",
    icon: <VerifiedUserIcon />,
  },
  content: {
    id: "content",
    name: "محتوا",
    icon: <SpeakerNotesIcon />,
  },
  forum: {
    id: "forum",
    name: "فروم",
    icon: <ForumIcon />,
  },
  avatar: {
    id: "avatar",
    name: "آواتار",
    icon: <PeopleIcon />,
  },
  user: {
    id: "user",
    name: "کاربر",
    icon: <PeopleIcon />,
  },
  conversation: {
    id: "conversation",
    name: "مکالمه‌ها و پیام‌ها",
    icon: <ChatIcon />,
  },
  shop: {
    id: "shop",
    name: "فروشگاه",
    icon: <ShoppingCartIcon />,
  },
  userLogs: {
    id: "userLogs",
    name: "لاگ‌های کاربران",
    icon: <PeopleIcon />,
  },
  specialists: {
    id: "specialists",
    name: "پزشکان",
    icon: <PeopleIcon />,
  },
  blog: {
    id: "blog",
    name: "بلاگ",
    icon: <SpeakerNotesIcon />,
  },
  advice: {
    id: "advice",
    name: "توصیه‌ها",
    icon: <SpeakerNotesIcon />,
  },
  ads: {
    id: "ads",
    name: "تبلیغات",
    icon: <SpeakerNotesIcon />,
  },
  pregnancy: {
    id: "pregnancy",
    name: "بارداری",
    icon: <SpeakerNotesIcon />,
  },
  abtest: {
    id: "abtest",
    name: "A/B Test",
    icon: <SpeakerNotesIcon />,
  },
};

export const MenuIsOpenState = {
  adminUsers: false,
  advice: false,
  blog: false,
  blogCategory: false,
  forumCategory: false,
  periods: false,
  config: false,
  user: false,
};
